import { locale } from './vue-i18n';

const moment = require('moment');
try {
  // Default locale is "en", but in the locales folder there are multiple "en"
  //  language files
  if (locale !== 'en') {
    require('moment/locale/' + locale);
  }
} catch (exception) {
  console.warn(`Cannot find locale: ${ locale }. Original exception:`);
  console.warn(exception);
}
moment.locale(locale);

let format = {
  date: '',
  time: '',
};
switch (locale) {
  default:
  case 'en':
    format = {
      shortDate: 'YYYY MMM',
      date: 'MMM DD, YYYY',
      time: 'h:mm a',
    };
    break;
  case 'ja':
    format = {
      shortDate: 'MMM dddd',
      date: 'MMM Do dddd',
      time: 'HH:mm',
    };
    break;
}

export {
  moment,
  format,
};
